import type { SubCondition } from './HubOptionState.types';
import { ConditionQuantifier } from './HubOptionState.types';

export type BorderCondition = {
  uuid: string;
  color: string;
  quantifier: ConditionQuantifier;
  subConditions: SubCondition[];
};

export const HUB_MAX_BORDER_CONDITIONS = 5;
